import React, { useEffect, useState } from "react";
import InvoiceForm from "./InvoiceForm";
import InvoiceList from "./InvoiceList";
import InvoiceView from "./InvoiceView";

const Invoice = () => {
  const [invoices, setInvoices] = useState([]);
  const [mode, setMode] = useState("LIST");
  const [selectedInvoice, setSelectedInvoice] = useState(null);


  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("invoices")) || [];
    setInvoices(data);
  }, []);


  const saveToStorage = (data) => {
    localStorage.setItem("invoices", JSON.stringify(data));
    setInvoices(data);
  };

  const addInvoice = (invoice) => {
    const updated = [...invoices, invoice];
    saveToStorage(updated);
    setMode("LIST");
  };

  const updateInvoice = (invoice) => {
    const updated = invoices.map((inv) =>
      inv.id === invoice.id ? invoice : inv
    );
    saveToStorage(updated);
    setMode("LIST");
  };

  const deleteInvoice = (id) => {
    if (!window.confirm("Delete this invoice?")) return;
    const updated = invoices.filter((inv) => inv.id !== id);
    saveToStorage(updated);
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">

      {mode === "LIST" && (
        <InvoiceList
          invoices={invoices}
          onCreate={() => {
            setSelectedInvoice(null);
            setMode("CREATE");
          }}
          onView={(inv) => {
            setSelectedInvoice(inv);
            setMode("VIEW");
          }}
          onEdit={(inv) => {
            setSelectedInvoice(inv);
            setMode("EDIT");
          }}
          onDelete={deleteInvoice}
        />
      )}

      {(mode === "CREATE" || mode === "EDIT") && (
        <InvoiceForm
          initialData={selectedInvoice}
          onCancel={() => setMode("LIST")}
          onSubmit={mode === "CREATE" ? addInvoice : updateInvoice}
        />
      )}

      {mode === "VIEW" && (
        <InvoiceView
          invoice={selectedInvoice}
          onBack={() => setMode("LIST")}
        />
      )}
    </div>
  );
};

export default Invoice;
